export default __webpack_public_path__ + "static/media/log.389b3d8c.svg";